/*
 *-----------------------------------------------------------------------------------------------------------
 * ACTIONS
 *-----------------------------------------------------------------------------------------------------------
 */
const LOAD_PAGE = "LOAD_PAGE";
const INSERT_ATIVIDADES = "INSERT_ATIVIDADES";
const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
const TOGGLE_LOADING = "TOGGLE_LOADING";
const LOGOUT = "LOGOUT";
const ACESSIBILIDADE_DATA = "ACESSIBILIDADE_DATA";
const GUIAS_PESQUISA = "GUIAS_PESQUISA";

export const loadPage = payload => ({type: LOAD_PAGE, payload});

export const insertAtividades = payload => ({type: INSERT_ATIVIDADES, payload})

export const changeLanguage = payload => ({type: CHANGE_LANGUAGE, payload})

export const toggleLoading = payload => ({type: TOGGLE_LOADING, payload})

export const acessibilidadeData = payload => ({ type: ACESSIBILIDADE_DATA, payload });

export const setGuiasPesquisa = payload => ({ type : GUIAS_PESQUISA, payload});
/*
 *-----------------------------------------------------------------------------------------------------------
 * ESTADO INICIAL
 *-----------------------------------------------------------------------------------------------------------
 */
const INITIAL_STATE = {
    status: false,
    atividades: [],
    acessibilidade: {
        zoom: 0,
        negrito: false,
        cor: '',
        libras: false
    },
    loading: false,
    guiasPesquisa: []
};

/*
 *-----------------------------------------------------------------------------------------------------------
 * REDUCERS
 *-----------------------------------------------------------------------------------------------------------
 */
const pageConfig = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case LOAD_PAGE:
            return { ...state, status: payload };
        case INSERT_ATIVIDADES:
            return { ...state, atividades: payload };
        case CHANGE_LANGUAGE:
            return { ...state, lng: payload };
        case TOGGLE_LOADING:
            return { ...state, loading: payload };
        case LOGOUT:
            return { isLoggedIn: false };
        case ACESSIBILIDADE_DATA:
            return { ...state, acessibilidade: payload };
        case GUIAS_PESQUISA:
            return { ...state, guiasPesquisa : payload};
        default:
            return state;
    }
};

export default pageConfig;
